import * as types from "../actions/actionTypes";
const initialState = {
  data: {},
  loading: true,
  error: ""
};

const announcement = (state = initialState, action) => {
  switch (action.type) {
    case types.ANNOUNCEMENT_SHOW_REQUEST:
      return { ...state, loading: true, error: "" };
    case types.ANNOUNCEMENT_SHOW_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payLoad.data
      };
    case types.ANNOUNCEMENT_SHOW_FAILURE:
      return { ...state, loading: false, error: action.error };

    default:
      return state;
  }
};

export default announcement;
